export const ProductsList = {
  GiftCards: {
    products: [
      {
        id: 1,
        name: "Sam's Club Gift Card",
        price: 50,
        sale_price: "",
        description:
          "A Sam’s Club Gift Card is the perfect way to shop smart and save big. Whether it’s groceries, electronics, exclusive member-only deals, this card gives you the freedom to choose from a wide variety of products at unbeatable value. Ideal for personal use or as a thoughtful gift.",
        image: "/assests/productimg/giftcards/1.jpg",
        details:
          "A Sam’s Club Gift Card is the perfect way to shop smart and save big. Whether it’s groceries, electronics, home essentials, or exclusive member-only deals, this card gives you the freedom to choose from a wide variety of products at unbeatable value. Ideal for personal use or as a thoughtful gift, it makes shopping at Sam’s Club convenient and rewarding. Elevate your photography with a powerful creative plan that includes advanced tools for editing, organizing, and sharing your images. This subscription comes with 1TB of cloud storage, giving you plenty of space to back up, access, and sync your photos across devices. Designed for both Windows and macOS, it offers flexibility and reliability for a single user through convenient digital download access.",
        category: "GiftCards",
      },
      {
        id: 2,
        name: "Digital Gift Card",
        price: 30,
        sale_price: "",
        description:
          "Give the gift of choice with this $30 digital gift card, delivered directly by email for instant use. Perfect for birthdays, holidays, or special occasions. Fast, secure, and easy to redeem with no expiration date.",
        image: "/assests/productimg/giftcards/2.webp",
        details:
          "Give the gift of choice with this $25 digital gift card, delivered directly by email for instant use. Perfect for birthdays, holidays, or special occasions, it allows the recipient to shop for apps, music, movies, games, subscriptions, and more across their favorite devices.Fast, secure, and easy to redeem, this eGift card offers flexibility and convenience with no expiration date.",
        category: "GiftCards",
      },
      {
        id: 3,
        name: "Birthday Digital Gift Card",
        price: 50,
        sale_price: "",
        description:
          "Celebrate birthdays with the perfect digital gift! Delivered instantly by email and available in various amounts, it’s a convenient and thoughtful choice for any celebration.",
        image: "/assests/productimg/giftcards/3.webp",
        details:
          "Celebrate birthdays with the perfect digital gift! This eGift card, available in amounts from $15 to $500, gives the recipient the freedom to choose from a wide range of apps, games, music, movies, and more.Delivered instantly by email, it’s fast, convenient, and ideal for last-minute gifting. Easy to redeem and with no expiration date, it’s a thoughtful choice for any celebration.",
        category: "GiftCards",
      },
      {
        id: 4,
        name: "Theme Park Gift Card",
        price: 25,
        sale_price: "",
        description:
          "Make memories that last with this $25 theme park gift card — perfect for admission, dining, and merchandise. Great for families and adventure seekers.",
        image: "/assests/productimg/giftcards/4.webp",
        details:
          "Make memories that last with this $25 theme park gift card — perfect for admission, dining, merchandise, and unforgettable experiences. Whether used for tickets, souvenirs, or special attractions, it offers flexibility and fun for any visitor.Ideal as a gift for families, friends, or adventure seekers, this card provides easy and convenient access to exciting entertainment and aquatic adventures.",
        category: "GiftCards",
      },
      {
        id: 5,
        name: "Starbucks $15 eGift Card",
        price: 15,
        sale_price: "",
        description:
          "Treat someone special with a $15 eGift Card—instant email delivery for coffee, drinks, and snacks.",
        image: "/assests/productimg/giftcards/5.webp",
        details:
          "Surprise your friends, family, or colleagues with the perfect treat! This $15 eGift Card allows the recipient to enjoy their favorite beverages, snacks, and small indulgences anytime they like. Delivered instantly via email, it’s convenient, thoughtful, and ready to use—no waiting, no shipping required. Whether it’s for a morning coffee, an afternoon pick-me-up, or a casual snack, this gift card gives them the freedom to choose what they love. Ideal for birthdays, holidays, celebrations, or simply to show appreciation, it’s a versatile and delightful way to brighten someone’s day.",
        category: "GiftCards",
      },
      {
        id: 6,
        name: "Disney $25 Gift Card",
        price: 25,
        sale_price: "",
        description:
          "Delight someone with a $25 gift card—perfect for movies, shows, merchandise, and more.",
        image: "/assests/productimg/giftcards/6.webp",
        details:
          "Bring joy and entertainment to someone special with this $25 gift card. Perfect for fans of movies, shows, games, and merchandise, this gift card offers endless options to enjoy and explore. Delivered instantly via email, it’s convenient, flexible, and ready to use, making it a hassle-free way to give a meaningful gift. Whether the recipient wants to catch the latest movie, enjoy a favorite show, or pick out exclusive merchandise, this card gives them the freedom to choose exactly what they want. Ideal for birthdays, holidays, or simply as a thoughtful surprise, it’s a fun and versatile gift that brings smiles and memorable experiences to anyone.",
        category: "GiftCards",
      },
      {
        id: 7,
        name: "Sesame Place Gift Card",
        price: 25,
        sale_price: "",
        description:
          "Give the gift of fun with a $25 gift card—perfect for theme park tickets, rides, and family adventures.",
        image: "/assests/productimg/giftcards/7.webp",
        details:
          "Delight friends or family with a $25 gift card for unforgettable theme park experiences. Perfect for rides, attractions, shows, and treats, this card gives the recipient the freedom to enjoy a fun-filled day their way. Delivered instantly via email, it’s a convenient and thoughtful gift for birthdays, holidays, or any special occasion. Whether planning a family outing or a day of adventure with friends, this gift card makes it easy to create lasting memories and magical moments that everyone will cherish.",
        category: "GiftCards",
      },
      {
        id: 8,
        name: "Charitable $25 Walmart",
        price: 25,
        sale_price: "",
        description:
          "Give a $25 charitable gift card—perfect for groceries, essentials, and everyday needs (excludes alcohol, tobacco, lottery).",
        image: "/assests/productimg/giftcards/8.webp",
        details:
          "Support someone special with a $25 charitable gift card, ideal for groceries, household essentials, and everyday purchases. Delivered instantly via email, it’s a convenient and thoughtful way to help friends, family, or colleagues get what they need while giving them the freedom to choose. Please note that this gift card cannot be used for alcohol, tobacco, lottery tickets. Perfect for birthdays, holidays, or acts of kindness, it’s a practical and meaningful gift that makes a positive difference in someone’s day.",
        category: "GiftCards",
      },
    ],
  },
  Saas: {
    products: [
      {
        id: 1,
        name: "Creative Cloud for Windows/Mac, 1-Year Student & Teacher Subscription",
        price: 302.99,
        sale_price: "",
        description:
          "All-in-one creative suite for students and teachers with tools for design, editing, and web development.",
        image: "/assests/productimg/saasproducts/1.webp",
        details:
          "Unlock your creativity with this all-in-one creative software suite, designed for Windows and Mac. Perfect for students and teachers, this 1-year subscription provides access to industry-standard tools for design, photo editing, video production, illustration, web development, and more. Whether you’re working on school projects, professional assignments, or personal creations, this package gives you everything you need to bring your ideas to life.",
        category: "Saas",
      },
      {
        id: 2,
        name: "Creative Cloud Photography Plan 1TB",
        price: 242.99,
        sale_price: "",
        description:
          "Advanced photography tools with 1TB cloud storage for editing, organizing, and sharing photos across devices.",
        image: "/assests/productimg/saasproducts/2.webp",
        details:
          " Elevate your photography with a powerful creative plan that includes advanced tools for editing, organizing, and sharing your images. This subscription comes with 1TB of cloud storage, giving you plenty of space to back up, access, and sync your photos across devices. Designed for both Windows and macOS, it offers flexibility and reliability for a single user through convenient digital download access.",
        category: "Saas",
      },
      {
        id: 3,
        name: "Photoshop & Premiere Elements 2025 Student & Teacher (3-Year License)",
        price: 83.99,
        sale_price: "",
        description:
          "Photo and video editing suite designed for education — professional-grade tools for creative learning.",
        image: "/assests/productimg/saasproducts/3.webp",
        details:
          "Unlock your creativity with a powerful editing bundle designed for students and teachers. This 3-year license provides access to professional-grade tools for both photo and video editing, making it easier than ever to enhance images, create stunning graphics, and produce cinematic-quality videos. Whether for school projects, personal creations, or professional learning, this package is tailored to support creativity in education.",
        category: "Saas",
      },
      {
        id: 4,
        name: "365 Family Subscription (30 Devices, 6 Users, 1 Year)",
        price: 132.99,
        sale_price: "",
        description:
          "All-in-one productivity subscription for up to 6 users with Office apps, storage, and collaboration tools.",
        image: "/assests/productimg/saasproducts/4.webp",
        details:
          "Get the ultimate productivity solution for your household with this all-in-one family subscription. Designed to support up to 6 users across as many as 30 devices, this 1-year plan provides access to essential productivity tools, cloud storage, and collaboration features that keep your family connected, organized, and secure.",
        category: "Saas",
      },
      {
        id: 5,
        name: "365 Personal (6-Month, 1 User)",
        price: 53.99,
        sale_price: "",
        description:
          "Personal Office subscription with 1TB cloud storage and premium apps for productivity and organization.",
        image: "/assests/productimg/saasproducts/5.webp",
        details:
          "Get the tools you need to stay productive, organized, and connected with a 6-month subscription designed for one person. This plan includes premium office applications, cloud-based features, and access across your devices for seamless work and personal use. With 1TB of secure OneDrive cloud storage, you can safely store, share, and access your files anytime, anywhere.",
        category: "Saas",
      },
      {
        id: 6,
        name: "Total Protection Antivirus & Internet Security Software",
        price: 28.99,
        sale_price: "",
        description:
          "Comprehensive antivirus solution with real-time protection for up to 5 devices.",
        image: "/assests/productimg/saasproducts/6.webp",
        details:
          "Protect your digital world with this comprehensive antivirus and internet security solution. Designed for Windows, macOS, Android, iOS, and ChromeOS, it provides real-time protection against viruses, malware, phishing, and online threats.This 1-year subscription covers up to 5 devices and includes automatic updates for continuous security. With built-in privacy tools, password management, and secure browsing features, your data and identity stay protected wherever you go.",
        category: "Saas",
      },
      {
        id: 7,
        name: "Antivirus Plus Software – 1-Year, 5 Devices",
        price: 23.99,
        sale_price: "",
        description:
          "Advanced antivirus software protecting PCs and Macs against viruses, malware, and ransomware.",
        image: "/assests/productimg/saasproducts/7.png",
        details:
          "Keep your devices secure with this advanced antivirus software, designed to protect PCs and Macs from viruses, malware, spyware, and ransomware. The 1-year subscription covers up to 5 devices, offering powerful, real-time protection for your digital life.Easily download and install the software digitally for instant access. It includes smart firewall protection, password management tools, and automatic updates to ensure you’re always safeguarded online.",
        category: "Saas",
      },
      {
        id: 8,
        name: "Antivirus & Internet Security Software – 1-Year, 1 PC",
        price: 17.99,
        sale_price: "",
        description:
          "Reliable antivirus protection for Windows PC with real-time defense against malware and phishing.",
        image: "/assests/productimg/saasproducts/8.webp",
        details:
          "Safeguard your computer with this reliable antivirus and internet security software designed for Windows PCs. It provides powerful real-time protection against viruses, malware, spyware, and phishing attacks, keeping your system safe and secure.The 1-year subscription ensures continuous protection with automatic updates and easy installation. Ideal for personal or home use, it offers advanced security tools for browsing, shopping, and banking online with confidence.",
        category: "Saas",
      },
    ],
  },
  HomeSecurity: {
    products: [
      {
        id: 1,
        name: "Auto Focus 2.8-12mm Night Vision Camera",
        price: 142.0,
        sale_price: "",
        description:
          "HD-SDI compatible night vision camera with auto-focus lens and dual video output for reliable surveillance.",
        image: "/assests/productimg/home-security/1.webp",
        details:
          "Experience high-definition security with the X Series CCTV camera featuring HD-SDI, EX-SDI, HD-TVI, HD-CVI, and HD-AHD compatibility. Equipped with an auto-focus 2.8–12mm lens, this camera ensures crystal-clear visuals day and night. Dual video output and advanced night vision provide reliable surveillance, making it a perfect choice for both home and business security.",
        category: "HomeSecurity",
      },
      {
        id: 2,
        name: "Security Cameras Day Night Waterproof",
        price: 22.99,
        sale_price: "",
        description:
          "2MP HD 1080P waterproof security camera with IR night vision and durable metal housing.",
        image: "/assests/productimg/home-security/2.webp",
        details:
          "Enjoy reliable security monitoring with this 2.0 Megapixel HD 1080P 4-in-1 security camera, supporting TVI, CVI, AHD, and CVBS formats. Designed with durable aluminum metal housing, it delivers sharp video quality both day and night, with up to 100ft IR night vision. Waterproof and built to withstand outdoor conditions, it is compatible with HD-TVI, AHD, CVI, and CVBS/960H analog DVR systems for flexible installation.",
        category: "HomeSecurity",
      },
      {
        id: 3,
        name: "Portable 1080P WiFi Camera Police Body",
        price: 20.74,
        sale_price: "",
        description:
          "Compact WiFi-enabled body camera with 180° viewing angle and infrared night vision.",
        image: "/assests/productimg/home-security/3.webp",
        details:
          "Capture every detail with this portable 1080P WiFi body camera, designed for clear HD recording with a wide 180° viewing angle. Equipped with DVR functionality and infrared night vision, it ensures reliable video footage day or night. Compact and easy to carry, it’s perfect for security, law enforcement, or personal safety use.",
        category: "HomeSecurity",
      },
      {
        id: 4,
        name: "Indoor Security Camera – 2-Pack, 1080p HD, Wi-Fi 6",
        price: 37.99,
        sale_price: "",
        description:
          "2-pack indoor security cameras with HD resolution and Wi-Fi 6 for reliable real-time monitoring.",
        image: "/assests/productimg/home-security/4.webp",
        details:
          "Keep your home safe and monitored with this 2-pack indoor security camera set. Featuring 1080p HD resolution and Wi-Fi 6 connectivity, it delivers clear, real-time video for reliable home surveillance.Designed for easy installation, these wired cameras provide continuous monitoring of key areas in your home. Ideal for living rooms, entryways, nurseries, or offices, they combine advanced technology with user-friendly features to enhance security and peace of mind.",
        category: "HomeSecurity",
      },
    ],
  },
  HomeDecor: {
    products: [
      {
        id: 1,
        name: "Full Length Mirror",
        price: 58.99,
        sale_price: "",
        description:
          "Elegant arched-top mirror with gold frame, perfect for bedrooms or living spaces.",
        image: "/assests/productimg/homedecorproducts/1.png",
        details:
          "Add a touch of elegance and brightness to any room with this beautifully designed full-length mirror. The arched top creates a soft, modern look that complements both classic and contemporary interiors. Measuring 64 x 21, it provides a complete reflection for dressing or room decor.The sturdy aluminum alloy frame with a sleek gold finish enhances durability while giving a luxurious appeal. It can be easily leaned against the wall or mounted for versatile placement in bedrooms, living rooms, or hallways. The high-definition glass ensures a clear, distortion-free reflection for everyday use.",
        category: "HomeDecor",
      },
      {
        id: 2,
        name: "Family Tree Wall Decor",
        price: 22.81,
        sale_price: "",
        description:
          "Acrylic 3D wall decor to display family photos in an elegant tree design.",
        image: "/assests/productimg/homedecorproducts/2.png",
        details:
          "Create a stunning visual story of your family’s most cherished moments with this elegant Family Tree Picture Frame Collage. Designed to beautifully display your favorite 4x6, 5x7, 8x10, and 11x14 photos, this 3D wall decor brings warmth and personality to any space.Crafted from high-quality acrylic, the design features a detailed tree silhouette that symbolizes family roots and growth. The lightweight, durable material ensures easy installation on living room, bedroom, or hallway walls. Perfect for DIY enthusiasts, the layout can be customized to suit your style and wall space.",
        category: "HomeDecor",
      },
      {
        id: 3,
        name: "Wood Floating Shelves",
        price: 15.64,
        sale_price: "",
        description:
          "Set of two minimalist natural wood floating shelves for photos, books, or decor.",
        image: "/assests/productimg/homedecorproducts/3.png",
        details:
          "Add a touch of simplicity and style to your home with this set of two natural wood floating shelves. Measuring 16.5 inches each, these sleek and versatile shelves are perfect for displaying photos, plants, books, or decorative accents.The sturdy wooden construction ensures durability, while the minimalist floating design creates a modern, space-saving storage solution. Ideal for use in living rooms, bedrooms, bathrooms, or kitchens, these shelves blend seamlessly with any decor style — from rustic to contemporary.",
        category: "HomeDecor",
      },
      {
        id: 4,
        name: "6ft Artificial Olive Tree",
        price: 39.99,
        sale_price: "",
        description:
          "Realistic olive tree with natural wood trunk, perfect for indoor spaces.",
        image: "/assests/productimg/homedecorproducts/4.png",
        details:
          "Bring a touch of Mediterranean charm to your space with this stunning 6ft artificial olive tree. Crafted with a natural wood trunk and realistic olive leaves and fruits, this tall faux plant adds warmth, freshness, and elegance to any room — without the need for maintenance.Perfect for living rooms, offices, bedrooms, or entryways, its lifelike design enhances your interior decor year-round. The sturdy base ensures stability, while the flexible branches allow for easy shaping to suit your preferred style.",
        category: "HomeDecor",
      },
      {
        id: 5,
        name: "Mini Ball Base Table Lamp",
        price: 15.7,
        sale_price: "",
        description:
          "Compact 12.75-inch lamp with soft fabric shade and modern design.",
        image: "/assests/productimg/homedecorproducts/5.jpeg",
        details:
          "Brighten up any room with this stylish mini table lamp featuring a smooth ball-shaped base and a compact 12.75-inch height. Its modern yet simple design makes it a perfect accent for bedrooms, living rooms, offices, or dorms.The sturdy base provides stability, while the soft fabric lampshade diffuses light gently for a warm and inviting glow. Ideal for nightstands, desks, or side tables, this lamp complements a variety of decor styles — from minimalist to contemporary.",
        category: "HomeDecor",
      },
      {
        id: 6,
        name: "2-Pack Almond Scented Candles",
        price: 76.97,
        sale_price: "",
        description:
          "Set of two almond-scented candles that add warmth and luxury to your home.",
        image: "/assests/productimg/homedecorproducts/6.webp",
        details:
          "Create a warm, relaxing ambiance with this set of two luxurious almond-scented candles. Each candle (70g / 2.4oz) is delicately crafted to fill your space with a rich, comforting aroma of sweet almond — perfect for cozy evenings or elegant home decor.Packaged in plain white boxes, these candles make a thoughtful gift or a simple treat for yourself. The compact size is ideal for bedrooms, bathrooms, or workspaces, offering long-lasting fragrance and a soft, soothing glow.",
        category: "HomeDecor",
      },
      {
        id: 7,
        name: "5-Shelf Bookcase",
        price: 42.88,
        sale_price: "",
        description:
          "White bookcase with adjustable shelves for storage and decor.",
        image: "/assests/productimg/homedecorproducts/7.1.webp",
        details:
          "Organize and display your favorite books, decor, and essentials with this spacious 5-shelf bookcase. Designed in a clean white finish, it complements any interior style — from modern to classic. The adjustable shelves let you customize the height to fit books, plants, photo frames, or collectibles with ease.Built from durable materials, this sturdy bookcase provides reliable storage for living rooms, bedrooms, home offices, or study areas. Its sleek, minimalist design makes it both functional and stylish, helping you keep your space neat and organized.",
        category: "HomeDecor",
      },
      {
        id: 8,
        name: "3-Cube Storage Organizer – Acorn Finish",
        price: 40.8,
        sale_price: "",
        description:
          "Warm acorn-finished 3-cube organizer ideal for versatile storage.",
        image: "/assests/productimg/homedecorproducts/8.1.webp",
        details:
          "Add function and style to your home with this versatile 3-cube storage organizer. Featuring a warm acorn wood finish, this organizer blends seamlessly with both modern and rustic decor. The open-cube design offers flexible storage options for books, decor pieces, baskets, or everyday essentials.Perfect for living rooms, bedrooms, offices, or entryways, it can be positioned vertically or horizontally to suit your space. The sturdy construction ensures durability and stability, making it a practical and attractive addition to any room.",
        category: "HomeDecor",
      },
      {
        id: 9,
        name: "4-Cube Storage Organizer – White Textured Finish",
        price: 47.99,
        sale_price: "",
        description:
          "White textured cube organizer with flexible vertical or horizontal layout.",
        image: "/assests/productimg/homedecorproducts/9.2.webp",
        details:
          "Bring organization and style to your space with this versatile 4-cube storage organizer. Featuring a clean white textured finish, it seamlessly complements modern, minimalist, or contemporary decor. The four spacious cubes provide flexible storage for books, decor items, baskets, or daily essentials.Durably built, this organizer can be used vertically or horizontally, making it perfect for living rooms, bedrooms, home offices, or entryways. Its sleek design adds a polished look while keeping your space tidy and functional.",
        category: "HomeDecor",
      },
      {
        id: 10,
        name: "Linear Gallery Collage Picture Frame",
        price: 15.1,
        sale_price: "",
        description:
          "Showcase your favorite memories with this 4x6 8-opening linear gallery collage picture frame in a sleek black finish. Designed to hold eight photos, it offers a modern and stylish way to display your cherished moments in one elegant frame, perfect for any room in your home or office.",
        image: "/assests/productimg/photoframe/1.webp",
        details:
          "Showcase your favorite memories with this 4x6 8-opening linear gallery collage picture frame in a sleek black finish. Designed to hold eight photos, it offers a modern and stylish way to display your cherished moments in one elegant frame, perfect for any room in your home or office.",
        category: "HomeDecor",
      },
      {
        id: 11,
        name: "7-Opening Collage Picture Frame, Natural",
        price: 19.2,
        sale_price: "",
        description:
          "Display your treasured memories in style with this 18 x 18 7-opening collage picture frame in a natural finish. Featuring seven spaces for photos, it provides a warm and contemporary way to showcase family, friends, or special moments, making it a perfect addition to any living space or office decor.",

        image: "/assests/productimg/photoframe/2.webp",
        details:
          "Display your treasured memories in style with this 18 x 18 7-opening collage picture frame in a natural finish. Featuring seven spaces for photos, it provides a warm and contemporary way to showcase family, friends, or special moments, making it a perfect addition to any living space or office decor.",
        category: "HomeDecor",
      },
      {
        id: 12,
        name: "8 x 10 Picture Frame, Gallery Wall Frame",
        price: 11.99,
        sale_price: "",
        description:
          "Showcase your favorite memories with this classic 8 x 10 black picture frame. Perfect for gallery wall displays or standalone use, it adds a sleek and timeless touch to your home or office decor while keeping your photos protected and beautifully presented.",
        image: "/assests/productimg/photoframe/3.webp",
        details:
          "Showcase your favorite memories with this classic 8 x 10 black picture frame. Perfect for gallery wall displays or standalone use, it adds a sleek and timeless touch to your home or office decor while keeping your photos protected and beautifully presented.",
        category: "HomeDecor",
      },
    ],
  },
  Furniture: {
    products: [
      {
        id: 1,
        name: "Oversized Chaise Lounge Chair – Plush Corduroy",
        price: 705.1,
        sale_price: 305.1,
        description:
          "Soft, oversized lounge chair that doubles as a sleeper couch.",
        image: "/assests/productimg/furnitureproducts/1.png",
        details:
          "Relax in style and comfort with this oversized chaise lounge chair, perfect for living rooms, bedrooms, or cozy reading corners. Upholstered in soft, durable corduroy fabric, it offers a plush seating experience that doubles as a cozy sleeper couch when needed.With no assembly required, this lounge chair is ready to use right out of the box. Its versatile design combines the functionality of a sofa bed with the elegance of a modern accent piece, making it an ideal addition to any home decor.",
        category: "Furniture",
      },
      {
        id: 2,
        name: "Stowaway Coffee Table with Storage – Cream Finish",
        price: 201.5,
        sale_price: 177.0,
        description:
          "Modern coffee table with hidden storage compartment and smooth cream finish.",
        image: "/assests/productimg/furnitureproducts/2.1.jpeg",
        details:
          "Enhance your living space with this elegant stowaway coffee table, designed to combine style and functionality. The cream-colored finish adds a light, modern touch, while the clever storage compartment helps keep your living room organized and clutter-free.Crafted from durable materials, this coffee table features a smooth tabletop perfect for displaying decor, serving drinks, or holding everyday essentials. Its compact yet functional design makes it ideal for small apartments, family rooms, or cozy living spaces.",
        category: "Furniture",
      },
      {
        id: 3,
        name: "Velvet Sofa – Copper Pipe Finish",
        price: 331.99,
        sale_price: 267.0,
        description:
          "Luxurious velvet sofa with copper frame for modern interiors.",
        image: "/assests/productimg/furnitureproducts/3.3.png",
        details:
          "Elevate your living space with this elegant velvet sofa featuring a rich copper-toned frame. Upholstered in soft, luxurious velvet, it provides a comfortable seating experience while adding a touch of sophistication to any room.The sturdy frame ensures durability, and its sleek design complements modern, contemporary, or eclectic decor styles. Perfect for living rooms, lounges, or offices, this sofa combines style, comfort, and functionality in one stunning piece of furniture.",
        category: "Furniture",
      },
      {
        id: 4,
        name: "Caning Accent Chair – Light Honey Finish",
        price: 171.99,
        sale_price: 151.1,
        description:
          "Elegant caning chair with woven backrest for classic charm.",
        image: "/assests/productimg/furnitureproducts/4.1.jpeg",
        details:
          "Add a touch of classic elegance to your space with this stylish caning accent chair. The light honey finish complements a variety of decor styles, from modern to traditional, while the woven cane backrest adds texture and timeless charm.Comfortable and versatile, this chair is perfect for dining rooms, living areas, bedrooms, or entryways. Its sturdy frame ensures durability, making it a practical yet decorative addition to your home.",
        category: "Furniture",
      },
      {
        id: 5,

        name: "6 Twin Size Innerspring Mattress",
        price: 189.71,
        sale_price: 70.88,
        description:
          "Medium-firm twin mattress with supportive innerspring system.",
        image: "/assests/productimg/furnitureproducts/5.1.png",
        details:
          "Experience a comfortable and supportive sleep with this 6-inch twin size innerspring mattress. Designed with medium firmness, it provides balanced support for a restful night while adapting to your body’s natural contours.The durable innerspring system ensures long-lasting comfort and proper spinal alignment, making it ideal for kids, guests, or smaller bedrooms. Lightweight and easy to handle, this mattress pairs well with standard twin bed frames, bunk beds, or daybeds.",
        category: "Furniture",
      },
      {
        id: 6,

        name: "Set of 2 Adjustable Bar Stools – Black PU Leather",
        price: 104.99,
        sale_price: 72.99,
        description:
          "Modern adjustable-height bar stools with swivel and PU leather seat.",
        image: "/assests/productimg/furnitureproducts/6.1.webp",
        details:
          "Upgrade your kitchen or home bar with this set of 2 modern bar stools. Featuring comfortable PU leather upholstery and a supportive backrest, these stools offer both style and practicality. The hydraulic height-adjustable mechanism allows easy customization to counter or island heights, while the 360° swivel function provides effortless movement and accessibility.Durable and easy to clean, these stools combine contemporary design with everyday functionality, making them ideal for kitchens, breakfast bars, or entertainment areas.",
        category: "Furniture",
      },
      {
        id: 7,
        name: "12 King Size Gel Memory Foam Hybrid Mattress",
        price: 999.99,
        sale_price: 401.99,
        description: "Hybrid gel memory foam king mattress with bonus pillows.",
        image: "/assests/productimg/furnitureproducts/7.png",
        details:
          "Experience ultimate comfort and support with this 12-inch king size hybrid mattress. Combining memory foam with an innerspring system, it delivers balanced support while contouring to your body for pressure relief. The hyper-cooling gel layer helps regulate temperature for a cooler, more restful sleep.This mattress includes bonus pillows for added comfort and convenience. Its durable construction ensures long-lasting performance, making it perfect for master bedrooms, guest rooms, or anyone seeking a luxurious, supportive sleep experience.",
        category: "Furniture",
      },
      {
        id: 8,
        name: '10" Queen Size Memory Foam Mattress with Cooling Gel',
        price: 302.1,
        sale_price: "",
        description:
          "Cooling gel queen mattress with motion isolation and spinal support.",
        image: "/assests/productimg/furnitureproducts/8.png",
        details:
          "Enjoy a restful night with this 10-inch queen size memory foam mattress, designed for comfort, support, and cooling. The gel-infused memory foam helps regulate temperature, keeping you cool throughout the night. Its motion isolation feature ensures minimal disturbance from a partner’s movements, promoting uninterrupted, rejuvenating sleep.Crafted for pressure relief and spinal alignment, this mattress combines comfort and durability, making it perfect for bedrooms of all sizes. Experience a refreshing, restorative sleep every night",
        category: "Furniture",
      },
    ],
  },
  FireSafety: {
    products: [
      {
        id: 1,
        name: "Emergency Fire Extinguisher Blanket",
        price: 22.99,
        sale_price: "",
        description:
          "Durable fire blanket for quick response to small fires at home or office.",
        image: "/assests/productimg/firesafety/1.webp",
        details:
          "Enhance your home or workspace safety with this emergency fire extinguisher blanket. Designed for quick and effective use, it helps smother small fires in kitchens, offices, or vehicles, providing a crucial first line of defense.Compact and easy to store, this blanket is simple to deploy in emergencies. Made from durable, heat-resistant material, it offers reliable protection while keeping you and your surroundings safe.",
        category: "FireSafety",
      },
      {
        id: 2,
        name: "Emergency Fire & First Aid Blanket",
        price: 10,
        sale_price: "",
        description:
          "Multi-purpose fire and first aid blanket made from heat-resistant material.",
        image: "/assests/productimg/firesafety/2.webp",
        details:
          "Be prepared for unexpected emergencies with this versatile fire and first aid blanket. Crafted from durable, heat-resistant material, it can help smother small fires or provide warmth and protection in first aid situations.Compact and lightweight, this green emergency blanket is easy to store in homes, offices, vehicles, or outdoor kits. Ideal for safety-conscious households or workplaces, it offers peace of mind when accidents or emergencies occur.",
        category: "FireSafety",
      },
      {
        id: 3,
        name: "Multipurpose Home Fire Extinguisher",
        price: 52.6,
        sale_price: "",
        description:
          "ABC-rated fire extinguisher suitable for common household fires.",
        image: "/assests/productimg/firesafety/3.webp",
        details:
          "Ensure your home’s safety with this multipurpose fire extinguisher, designed for residential use. Rated 3A40BC, it effectively tackles common household fires, including those fueled by wood, paper, flammable liquids, and electrical equipment.Compact and easy to handle, this extinguisher features a reliable pressure gauge, durable construction, and user-friendly operation for quick response during emergencies. Ideal for kitchens, garages, living rooms, or any area of your home, it provides peace of mind when safety matters most.",
        category: "FireSafety",
      },
      {
        id: 4,
        name: "Home Fire Extinguisher",
        price: 31.99,
        sale_price: "",
        description:
          "Compact ABC-rated extinguisher with quick-release handle for fast use.",
        image: "/assests/productimg/firesafety/4.webp",
        details:
          "Be prepared for household emergencies with this ABC-rated 2.5 lb fire extinguisher. Designed to tackle Class A (wood, paper), Class B (flammable liquids), and Class C (electrical) fires, it provides versatile protection for your home.The quick-release handle allows fast and easy operation, while its compact design ensures convenient storage in kitchens, garages, bedrooms, or offices. Durable and reliable, this extinguisher is an essential safety tool for every household.",
        category: "FireSafety",
      },
      {
        id: 5,
        name: "Leather Welding Gloves",
        price: 16.58,
        sale_price: "",
        description:
          "Protect your hands with these 16-inch leather welding gloves—fireproof, heat-resistant, and designed for heavy-duty work.",
        image: "/assests/productimg/firesafety/5.webp",
        details:
          "Ensure maximum safety during welding, metalwork, or other high-heat tasks with these 16-inch leather welding gloves. Made from durable, high-quality leather, they provide excellent heat and fire resistance while protecting your hands and forearms from sparks, burns, and abrasions. The large size offers a comfortable fit without restricting movement, making them ideal for professional welders, hobbyists, and industrial use. Sturdy, reliable, and built to last, these gloves combine safety, comfort, and performance for all your heavy-duty work needs.",
        category: "FireSafety",
      },
      {
        id: 6,
        name: "Combustible Gas Alarm",
        price: 11.89,
        sale_price: "",
        description:
          "Stay safe at home with this compact combustible gas alarm—perfect for kitchens and living areas, measuring 10.5 x 10.5 x 3.3 cm.",
        image: "/assests/productimg/firesafety/6.webp",
        details:
          "Enhance the safety of your home or kitchen with this compact combustible gas alarm. Designed to detect harmful gases, it provides early warning to prevent potential hazards and keep your family safe. Its sleek white design blends seamlessly into any room, while the small footprint (10.5 x 10.5 x 3.3 cm) makes installation quick and convenient. Ideal for kitchens, living spaces, or anywhere gas appliances are used, this device combines reliability, ease of use, and peace of mind. Ensure your home is equipped with this essential safety tool for everyday protection.",
        category: "FireSafety",
      },
      {
        id: 7,
        name: "Smoke Detector – Lithium Battery",
        price: 30.88,
        sale_price: "",
        description:
          "Ensure home safety with this 5-inch photoelectric smoke detector—10-year sealed lithium battery for reliable, long-lasting protection.",
        image: "/assests/productimg/firesafety/7.webp",
        details:
          "Protect your home and loved ones with this Kidde 10-Year Smoke Detector. Featuring a photoelectric sensor, it quickly detects smoke from fires and alerts you with a loud alarm, giving you crucial time to act. The sealed lithium battery lasts up to 10 years, providing worry-free, long-term protection without the need for frequent battery changes. Compact at 5 inches, this smoke detector is easy to install and fits seamlessly into any room. Reliable, efficient, and durable, it’s an essential safety device for every home.",
        category: "FireSafety",
      },
      {
        id: 8,
        name: "Fire Suppression & Survival Blanket",
        price: 9.99,
        sale_price: "",
        description:
          "Stay prepared for emergencies with this 1m x 1m fire suppression blanket—flame-retardant, heat-insulated, and ideal for home or outdoor use.",
        image: "/assests/productimg/firesafety/8.webp",
        details:
          "Be ready for unexpected fires or emergencies with the SITERWELL Fire Suppression and Survival Blanket. Made from durable fiberglass, this blanket provides flame-retardant protection and excellent heat insulation to help smother small fires safely. Compact and easy to store, it’s perfect for kitchens, workshops, camping trips, or emergency survival kits. Measuring 1m x 1m, it’s lightweight yet strong enough to provide reliable protection in critical situations. A must-have safety tool, this survival blanket gives peace of mind by helping to prevent fire-related accidents and offering protection when it matters most.",
        category: "FireSafety",
      },
    ],
  },
  HairCare: {
    products: [
      {
        id: 1,
        name: "Hair Serum for Split Ends & Damaged Hair",
        price: 9.99,
        sale_price: "",
        description:
          "Lightweight serum that smooths frizz, repairs damage, and adds shine.",
        image: "/assests/productimg/haircare/1.webp",
        details:
          "Revive and protect your hair with this nourishing hair serum, specially formulated to target split ends and repair damage. Its lightweight formula penetrates deeply, smoothing frizz and adding shine without weighing hair down.Perfect for daily use on all hair types, it helps restore softness, manageability, and a healthy-looking finish. Keep your hair protected from breakage and environmental stressors while enjoying silky, smooth locks.",
        category: "HairCare",
      },
      {
        id: 2,
        name: "Weightless Nourishing Leave-In Detangler",
        price: 13.99,
        sale_price: 12.99,
        description:
          "Softens and detangles hair while protecting from breakage and frizz.",
        image: "/assests/productimg/haircare/2.webp",
        details:
          "Keep your hair smooth, soft, and manageable with this weightless leave-in detangler. Its nourishing formula gently detangles knots, reduces frizz, and adds shine without weighing hair down.Ideal for all hair types, it helps protect against breakage while leaving hair feeling silky and hydrated. Perfect for daily use, it makes combing and styling easier while promoting healthier, more manageable locks.",
        category: "HairCare",
      },
      {
        id: 3,
        name: "Anti-Frizz Finishing Hairspray",
        price: 9.99,
        sale_price: "",
        description:
          "Keratin-infused hairspray that provides flexible hold and shine.",
        image: "/assests/productimg/haircare/3.webp",
        details:
          "Tame frizz and keep your hairstyle in place with this weightless finishing hairspray. Formulated with keratin, it provides flexible hold while smoothing flyaways and adding shine without weighing hair down.Perfect for all hair types, it helps maintain sleek, polished styles throughout the day. Lightweight and non-sticky, it’s ideal for finishing blowouts, updos, or everyday hairstyles while keeping hair soft and touchable.",
        category: "HairCare",
      },
      {
        id: 4,
        name: "Grow Strong Conditioner",
        price: 12.99,
        sale_price: "",
        description:
          "Fortifying conditioner that strengthens and hydrates hair.",
        image: "/assests/productimg/haircare/4.webp",
        details:
          "Strengthen and nourish your hair with this daily conditioner. Its fortifying formula helps reduce breakage, leaving hair stronger, smoother, and more resilient. Ideal for all hair types, it works to hydrate and detangle strands, promoting healthier-looking hair from root to tip.Perfect for regular use, this conditioner enhances manageability and shine while protecting hair from everyday damage. The generous 33.8 fl. oz size is great for home use, ensuring long-lasting hair care.",
        category: "HairCare",
      },
      {
        id: 5,
        name: "Repair & Replenish Leave-In Treatment Spray for All Hair Types, with Avocado & Olive Oils, 13 fl oz",
        price: 18.49,
        sale_price: "",
        description:
          "Leave-in treatment spray with avocado and olive oils to nourish, repair, and protect all hair types.",
        image: "/assests/productimg/haircare/5.webp",
        details:
          "This leave-in treatment spray helps repair and replenish dry, damaged hair while providing lasting moisture and shine. Infused with avocado and olive oils, it nourishes and strengthens hair from root to tip, reducing breakage and frizz. Lightweight and non-greasy, it detangles and protects hair from heat and environmental damage. Suitable for all hair types, it leaves hair soft, smooth, and revitalized with every use.",
        category: "HairCare",
      },
      {
        id: 6,
        name: "Grow Strong Conditioner",
        price: 6.97,
        sale_price: "",
        description:
          "Anti-dandruff shampoo with 1% pyrithione zinc to fight flakes and itching, leaving hair soft and manageable.",
        image: "/assests/productimg/haircare/6.webp",
        details:
          "This nourishing dandruff shampoo is formulated with 1% pyrithione zinc to effectively combat dandruff and relieve itching and flaking. It cleanses the scalp and hair, leaving them feeling fresh and soft. Gentle enough for daily use, it helps maintain a healthy scalp and promotes manageable hair. Ideal for all hair types.  ",
        category: "HairCare",
      },
      {
        id: 7,
        name: "Bond Strength Conditioner with Bio-Protein Care Technology & Peptide Complex, 12 oz",
        price: 5.84,
        sale_price: "",
        description:
          "Conditioner formulated with Bio-Protein Care and Peptide Complex to repair and strengthen chemically damaged hair.",
        image: "/assests/productimg/haircare/7.webp",
        details:
          "This conditioner is designed to visibly repair signs of damage in chemically treated hair. Infused with Bio-Protein Care and Peptide Complex, it works at a molecular level to strengthen hair fibers and replenish lost proteins. Regular use helps reverse the effects of accumulated chemical damage, leaving hair stronger, smoother, and more manageable. Suitable for all hair types, it is PETA-approved and vegan-friendly.",
        category: "HairCare",
      },
      {
        id: 8,
        name: "21-in-1 Color Caring Leave-In Spray with Almond Milk & Rose Extract, 6.8 fl oz",
        price: 11.5,
        sale_price: "",
        description:
          "Multi-benefit leave-in spray for color-treated hair, offering 21 essential benefits including heat protection, detangling, and frizz control.",
        image: "/assests/productimg/haircare/8.webp",
        details:
          "This leave-in spray is formulated to protect and perfect color-treated hair by delivering 21 essential benefits in one treatment. Infused with almond milk and rose extract, it helps preserve color vibrancy, nourishes, and instantly detangles hair. The spray also provides up to 450°F heat protection, reduces breakage, adds shine, and controls frizz without weighing hair down. Free from sulfates, parabens, dyes, and gluten, it is suitable for all hair types and is vegan-friendly.",
        category: "HairCare",
      },
    ],
  },
  SkinCare: {
    products: [
      {
        id: 1,
        name: "Triple Bounce Hydration Serum",
        price: 14.99,
        sale_price: "",
        description:
          "Deep hydration serum that boosts elasticity and radiance.",
        image: "/assests/productimg/skincare/1.webp",
        details:
          "Revitalize and hydrate your skin with this lightweight triple-action serum. Formulated to deliver deep moisture, it helps improve skin elasticity, smoothness, and overall radiance. Perfect for all skin types, it absorbs quickly without leaving a greasy residue.Ideal for daily use, this serum boosts skin hydration and plumps up the complexion for a healthy, glowing appearance. Its convenient 1.0 fl. oz size is perfect for home use or travel.",
        category: "SkinCare",
      },
      {
        id: 2,
        name: "Hydrating Face Cream",
        price: 16.99,
        sale_price: "",
        description:
          "Lightweight moisturizer for soft, nourished, and glowing skin.",
        image: "/assests/productimg/skincare/2.webp",
        details:
          "Keep your skin soft, smooth, and nourished with this lightweight hydrating face cream. Formulated to deliver long-lasting moisture, it helps improve skin texture, soothe dryness, and maintain a healthy, radiant complexion.Ideal for daily use on all skin types, it absorbs quickly without leaving a greasy residue, making it perfect for morning and evening skincare routines.",
        category: "SkinCare",
      },
      {
        id: 3,
        name: "Vitamin C + E + Ferulic Face Serum",
        price: 19.99,
        sale_price: "",
        description:
          "Antioxidant-rich serum that brightens skin and reduces fine lines.",
        image: "/assests/productimg/skincare/3.webp",
        details:
          "Brighten and revitalize your skin with this powerful antioxidant face serum. Formulated with vitamins C and E along with ferulic acid, it helps reduce the appearance of dullness, uneven skin tone, and fine lines while protecting against environmental stressors.Lightweight and fast-absorbing, it’s suitable for all skin types and can be used daily to enhance radiance and promote a healthier, glowing complexion.",
        category: "SkinCare",
      },
      {
        id: 4,
        name: "Micro-Sculpting Face Serum",
        price: 30.1,
        sale_price: 22.99,
        description:
          "Advanced anti-aging serum that firms and smooths skin texture.",
        image: "/assests/productimg/skincare/4.webp",
        details:
          "Revitalize and hydrate your skin with this advanced micro-sculpting serum. Designed to reduce the appearance of fine lines and wrinkles, it promotes smoother, firmer, and more youthful-looking skin.Lightweight and fast-absorbing, this serum is suitable for all skin types and can be used daily as part of your skincare routine. Its moisturizing formula helps improve elasticity and leaves skin feeling soft and rejuvenated.",
        category: "SkinCare",
      },
      {
        id: 5,
        name: "Shea Better 24H Moisture Body Lotion",
        price: 11.99,
        sale_price: "",
        description:
          "Moisturizing body lotion for dry skin with shea butter and a warm vanilla-cashmere scent; absorbs quickly for soft, smooth skin.",
        image: "/assests/productimg/skincare/5.webp",
        details:
          "This nourishing body lotion provides 24-hour hydration for dry skin. Enriched with shea butter and shea oil, it soothes and protects while leaving skin feeling soft and smooth. Its lightweight, non-greasy formula absorbs quickly, and the comforting vanilla-cashmere fragrance creates a cozy, luxurious experience. Suitable for daily use, it is dermatologist-tested, vegan, cruelty-free, and free from parabens, phthalates, and gluten.",
        category: "SkinCare",
      },
      {
        id: 6,
        name: "Facial Spray Skin Care Toner with Rosewater and Aloe Vera",
        price: 6.48,
        sale_price: "",
        description:
          "Refreshing facial toner with rosewater and aloe vera to hydrate, soothe, and revitalize skin.",
        image: "/assests/productimg/skincare/6.webp",
        details:
          "This facial spray toner instantly refreshes and revitalizes the skin. Infused with rosewater and aloe vera, it helps soothe irritation, hydrate, and maintain the skin’s natural balance. Lightweight and gentle, it can be used throughout the day for a cooling, calming effect, leaving skin soft, smooth, and refreshed. Suitable for all skin types.",
        category: "SkinCare",
      },
      {
        id: 7,
        name: "Hyaluronic Eye Cream, Under Eye Brightening",
        price: 22.1,
        sale_price: "",
        description:
          "Hydrating eye cream with hyaluronic acid to brighten and refresh the under-eye area.",
        image: "/assests/productimg/skincare/7.webp",
        details:
          "This lightweight eye cream is formulated with hyaluronic acid to deeply hydrate and plump the delicate under-eye area. It helps reduce the appearance of dark circles and fine lines, leaving skin looking brighter, smoother, and refreshed. Gentle and suitable for daily use, it is perfect for maintaining a youthful, well-moisturized eye area.",
        category: "SkinCare",
      },
      {
        id: 8,
        name: "Acne Care Kit for All Skin Types",
        price: 25.99,
        sale_price: "",
        description:
          "Complete acne care kit with three essential products to cleanse, treat, and soothe skin for a clearer complexion.",
        image: "/assests/productimg/skincare/8.webp",
        details:
          "This acne care kit is designed for all skin types and includes three essential products to help combat breakouts and maintain healthy skin. The kit works to cleanse impurities, target acne-causing bacteria, and soothe irritated skin. With consistent use, it helps reduce blemishes, prevent future breakouts, and promote a clearer, smoother, and balanced complexion. Ideal for daily skincare routines.",
        category: "SkinCare",
      },
    ],
  },
  Wellness: {
    products: [
      {
        id: 1,
        name: "Herbal Defense Complex Capsules",
        price: 38.5,
        sale_price: "",
        description:
          "Natural herbal blend supporting immune system and daily vitality.",
        image: "/assests/productimg/wellness/1.webp",
        details:
          "Support your overall wellness with this herbal defense supplement. Formulated with a blend of natural herbs and nutrients, it helps maintain immune system health and promotes daily vitality.Ideal for adults seeking a convenient way to support their body’s natural defenses, these capsules are easy to incorporate into your daily routine. The 240-count supply ensures long-lasting use for consistent wellness support.",
        category: "Wellness",
      },
      {
        id: 2,
        name: "Liquid Multivitamin for Hair Growth",
        price: 77.99,
        sale_price: 55.5,
        description:
          "Biotin-rich liquid multivitamin promoting hair growth and  wellness.",
        image: "/assests/productimg/wellness/2.webp",
        details:
          "Support healthy hair and skin with this liquid multivitamin supplement. Clinically formulated for adults, it helps promote thicker hair, reduce the appearance of fine lines, and support overall wellness. Packed with 10,000 mcg of biotin, it nourishes hair follicles while enhancing skin vitality.Easy-to-use and fast-absorbing, this supplement is ideal for daily intake. Suitable for adults aged 18 and above, it provides a convenient way to support hair growth, skin health, and general wellness in one formula.",
        category: "Wellness",
      },
      {
        id: 3,
        name: "Vitamin B12 Tablets – 1000 mcg, 200 Count",
        price: 12.99,
        sale_price: 9.99,
        description:
          "High-potency B12 supplement for energy, metabolism, and nerve health.",
        image: "/assests/productimg/wellness/3.webp",
        details:
          "Support energy production and overall wellness with these high-potency Vitamin B12 tablets. Each tablet delivers 1000 mcg of B12, helping maintain healthy nerve function, red blood cell formation, and energy metabolism.Ideal for adults looking to support daily nutritional needs, these easy-to-take tablets provide a convenient and reliable way to boost your vitamin intake. The 200-count supply ensures long-lasting use.",
        category: "Wellness",
      },
      {
        id: 4,
        name: "Daily Immune Support Vitamin C Powder",
        price: 22.5,
        sale_price: 10.99,
        description:
          "The 30-count supply ensures a month of consistent immune support",
        image: "/assests/productimg/wellness/4.webp",
        details:
          "Boost your immune system daily with this convenient vitamin C supplement powder. Raspberry-flavored and easy to mix with water, it provides essential nutrients to support immune health, overall wellness, and daily energy.Perfect for adults seeking a quick and tasty way to supplement their diet, each tube delivers a potent dose of vitamin C. The 30-count supply ensures a month of consistent immune support.",
        category: "Wellness",
      },
      {
        id: 5,
        name: "L-Tryptophan 1000mg Tablets – 120 Count",
        price: 17.99,
        sale_price: "",
        description:
          "Support mood, sleep, and overall wellness with these high-potency L-Tryptophan tablets. L-Tryptophan is an essential amino acid that helps the body produce serotonin and melatonin, promoting relaxation and healthy sleep patterns.",
        image: "/assests/productimg/wellness/5.webp",
        details:
          "Support mood, sleep, and overall wellness with these high-potency L-Tryptophan tablets. L-Tryptophan is an essential amino acid that helps the body produce serotonin and melatonin, promoting relaxation and healthy sleep patterns.Ideal for adults seeking natural support for mental and emotional well-being, these easy-to-take tablets provide a convenient daily dose. The 120-count supply ensures long-term use for consistent benefits.",
        category: "Wellness",
      },
      {
        id: 6,
        name: "Ashwagandha Root Powder 500 mg – General Wellness Dietary Supplement",
        price: 9.99,
        sale_price: "",
        description:
          "Each vegetarian capsule contains 500 mg of organic Ashwagandha root powder, supporting stress relief and immune health.",
        image: "/assests/productimg/wellness/6.webp",
        details:
          "This dietary supplement offers 500 mg of organic Ashwagandha root powder per vegetarian capsule. Ashwagandha, also known as Withania somnifera, is an adaptogenic herb traditionally used to help the body manage stress and support overall wellness. Each bottle contains 60 capsules, providing a convenient way to incorporate Ashwagandha into your daily routine. The capsules are free from gluten, yeast, wheat, milk or milk derivatives, lactose, sugar, soy, and artificial colors and flavors, making them suitable for a variety of dietary preferences",
        category: "Wellness",
      },
      {
        id: 7,
        name: "Super Bio-Curcumin® Turmeric Extract, 400 mg, 60 Vegetarian Capsules",
        price: 20.1,
        sale_price: "",
        description:
          "Highly bioavailable turmeric extract with BCM-95® for enhanced absorption, supporting joint, brain, heart, and immune health.",
        image: "/assests/productimg/wellness/7.webp",
        details:
          "This turmeric extract supplement features BCM-95®, a patented curcumin formulation that is up to seven times more absorbable than standard curcumin. Each vegetarian capsule delivers 400 mg of BCM-95® Bio-Curcumin®, providing comprehensive support for joint comfort, cognitive function, cardiovascular health, and immune system function. The formula is non-GMO, gluten-free, and vegetarian-friendly, making it suitable for various dietary preferences.",
        category: "Wellness",
      },
      {
        id: 8,
        name: "CurcuBrain™ 400 mg with Longvida® Optimized Curcumin, 50 Veg Capsules",
        price: 19.99,
        sale_price: "",
        description:
          "High-absorption curcumin supplement (400 mg per capsule) using Longvida® technology to support cognitive and whole-body health.",
        image: "/assests/productimg/wellness/8.webp",
        details:
          "This vegetarian capsule supplement delivers 400 mg of Longvida® Optimized Curcumin extract (from turmeric root, minimum 20% curcuminoids). Studies show this patented formulation can offer up to 65× greater bioavailability than generic curcumin'.Cautions: For adults only. Consult a health professional if pregnant or nursing, taking medications, or if you have a medical condition (such as liver, gall-bladder or gastrointestinal issues). Keep out of reach of children.",
        category: "Wellness",
      },
    ],
  },

  WeightLoss: {
    products: [
      {
        id: 1,
        name: "Weight Loss Support Capsules",
        price: 38.99,
        sale_price: "",
        description:
          "The 90-count supply provides a full month of consistent use.",
        image: "/assests/productimg/weightloss/1.webp",
        details:
          "Support your weight management goals with this advanced dietary supplement. Designed to help boost metabolism and promote fat loss, these capsules complement a healthy diet and exercise routine for effective results.Ideal for adults seeking a convenient and natural weight loss solution, each capsule contains a blend of ingredients to support energy levels and metabolism throughout the day. The 90-count supply provides a full month of consistent use.",
        category: "WeightLoss",
      },
      {
        id: 2,
        name: "Sodium Butyrate Gut Health Supplement",
        price: 33.99,
        sale_price: "",
        description:
          "The 100-capsule supply ensures long-term use and easy integration into your wellness routine.",
        image: "/assests/productimg/weightloss/2.png",
        details:
          "Support digestive health and gut wellness, Weight loss with this sodium butyrate supplement. Designed to promote a healthy intestinal environment, it helps maintain gut lining integrity, supports nutrient absorption, and contributes to overall digestive balance.Ideal for adults looking to improve gut function, each capsule provides a convenient daily dose for consistent digestive support. The 100-capsule supply ensures long-term use and easy integration into your wellness routine.",
        category: "WeightLoss",
      },
      {
        id: 3,
        name: "Berberine Dietary Supplement",
        price: 14.99,
        sale_price: "",
        description:
          "vegetarian capsule delivers 1200 mg of berberine, a natural plant compound known to help regulate blood sugar levels.",
        image: "/assests/productimg/weightloss/3.webp",
        details:
          "Support healthy metabolism and overall wellness with this berberine dietary supplement. Each vegetarian capsule delivers 1200 mg of berberine, a natural plant compound known to help regulate blood sugar levels and promote metabolic balance.Ideal for adults looking to support healthy metabolic function, these easy-to-take capsules provide a convenient and effective addition to your daily wellness routine. The 40-count supply ensures a month of consistent use.",
        category: "WeightLoss",
      },
      {
        id: 4,
        name: "Hunger Control & Weight Loss Prebiotic Powder",
        price: 26.99,
        sale_price: "",
        description:
          "Support your weight management goals with this convenient prebiotic powder drink.",
        image: "/assests/productimg/weightloss/4.webp",
        details:
          "Support your weight management goals with this convenient prebiotic powder drink. Tropical peach-flavored and individually packed in 14 sticks, it helps curb appetite, control hunger, and support healthy metabolism.Designed for adults looking for an easy and tasty way to complement a healthy diet, this powder mixes quickly in water for on-the-go consumption. Its prebiotic content also promotes digestive health while assisting with weight management.",
        category: "WeightLoss",
      },
      {
        id: 5,
        name: "Green Tea Weight Loss Supplement, 90 Capsules",
        price: 25.55,
        sale_price: 11.99,
        description:
          "High-potency green tea extract supplement designed to support calorie burning, metabolism, and antioxidant protection",
        image: "/assests/productimg/weightloss/5.webp",
        details:
          "This dietary supplement features a concentrated green tea extract formula that delivers significant levels of EGCG (epigallocatechin gallate) and caffeine to support thermogenesis (calorie burning) and fat oxidation.Additional botanical blends (such as an antioxidant blend of super-fruits and a vitality blend including eleuthero, ginseng, etc.) are included to provide antioxidant support and enhance vitality.Intended for adult use as part of a reduced-calorie diet and exercise program. The product includes usage directions and warnings: it contains caffeine and may affect heart rate, blood pressure, or interact with certain medical conditions.As with any weight-management supplement, results depend on consistent diet and exercise and this product is not a standalone “fat-melter.",
        category: "WeightLoss",
      },
      {
        id: 6,
        name: "Red Yeast Rice 600 mg Capsules – Herbal Supplement, Non-GMO • Gluten-Free • 120 Count",
        price: 10.97,
        sale_price: 9.2,
        description:
          "Herbal supplement delivering 600 mg of red yeast rice per capsule, non-GMO and gluten-free.",
        image: "/assests/productimg/weightloss/6.webp",
        details:
          "Each vegetarian capsule contains 600 mg of red yeast rice powder from the botanical Monascus purpureus, a traditional herbal ingredient.The product is lab-tested for quality and manufactured to premium standards.It is free from artificial colors, flavors, and sweeteners, and is certified as non-GMO and gluten-free.Suggested use: For adults, take 2 capsules with a meal once or twice daily (do not exceed 4 capsules in a 24-hour period). These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, weight loss, cure, or prevent any disease.",
        category: "WeightLoss",
      },
      {
        id: 7,
        name: "Sugar Blocker Weight Loss Supplement – 90 Capsules",
        price: 11.99,
        sale_price: "",
        description:
          "Dietary supplement formulated to help reduce sugar absorption and curb sugar cravings, supporting weight-loss efforts",
        image: "/assests/productimg/weightloss/7.webp",
        details:
          "This weight-management supplement is designed for individuals aiming to reduce the impact of dietary sugars in their routine. It features key ingredients such as chromium (as polynicotinate), Gymnema Sylvestre leaf extract (standardised to 25% gymnemic acids), and vanadyl sulfate.According to the manufacturer, the formula is clinically shown to reduce sugar absorption by 37.7% within one hour.Suggested usage: take one capsule before each meal, up to three times per day.Additional features: labelled as gluten-free, non-GMO, and free of artificial colours and flavours.Note: This product does not replace a healthy diet and exercise regimen; results depend on lifestyle habits. Always consult a healthcare professional before starting a new supplement, especially if pregnant, nursing, or on medication.",
        category: "WeightLoss",
      },
      {
        id: 8,
        name: "Same-Day Premium Detox Drink – Tropical Flavor, 16 fl oz",
        price: 26.99,
        sale_price: "",
        description:
          "A powerful detox drink formulated with a blend of herbs, vitamins, and minerals to help cleanse and flush out body impurities in a single day.",
        image: "/assests/productimg/weightloss/8.webp",
        details:
          "This ready-to-drink detox solution is designed to provide a rapid cleanse, making it ideal for those needing a quick detoxification. The formula includes a proprietary blend of 6.7 grams of detoxifying ingredients such as creatine monohydrate, dandelion root and leaf extracts, turmeric root extract, juniper berry extract, echinacea purpurea leaf extract, ginger root powder, licorice root extract, milk thistle seed extract, uva ursi leaf extract, ligustrum berry extract, corn silk extract, apple pectin, guarana seed extract, and black pepper extract.",
        category: "WeightLoss",
      },
    ],
  },
  BathroomEssentials: {
    products: [
      {
        id: 1,
        name: "6-Piece Bamboo & Plastic Bathroom Accessories",
        price: 53.99,
        sale_price: 27.99,
        description:
          "Organize your bathroom in style with this 6-piece bathroom accessory set",
        image: "/assests/productimg/bathroomproducts/1.webp",
        details:
          "Organize your bathroom in style with this 6-piece bathroom accessory set, designed to maximize functionality in small spaces. Crafted from bamboo and durable plastic, each piece combines elegance with practicality. The set includes essentials such as a toothbrush cup, soap dispenser, soap dish, and other bath accessories, perfect for everyday use.Ideal for homes, hotels, offices, or guest bathrooms, the sleek black design adds a modern touch while maintaining durability and ease of cleaning. Keep your space tidy and stylish with this versatile bathroom set.",
        category: "BathroomEssentials",
      },
      {
        id: 2,
        name: "Toilet Bowl Cleaner",
        price: 3.5,
        sale_price: "",
        description:
          "Keep your bathroom sparkling clean with this 24-ounce toilet bowl cleaner.",
        image: "/assests/productimg/bathroomproducts/2.webp",
        details:
          "Keep your bathroom sparkling clean with this 24-ounce toilet bowl cleaner. Its fresh scent leaves your bathroom smelling pleasant while effectively removing stains, limescale, and bacteria. The thick formula clings to the bowl for deep cleaning and long-lasting freshness.Ideal for everyday use, this cleaner helps maintain hygiene and cleanliness in homes, offices, or commercial spaces. Easy to use and highly effective, it’s a must-have for a fresh and sanitary bathroom.",
        category: "BathroomEssentials",
      },
      {
        id: 3,
        name: "Toilet Brush Set with Holder",
        price: 43.5,
        sale_price: "",
        description:
          "Keep your bathroom clean and hygienic with this all-in-one toilet brush set",
        image: "/assests/productimg/bathroomproducts/3.png",
        details:
          "Keep your bathroom clean and hygienic with this all-in-one toilet brush set. The kit includes a sturdy brush, convenient holder, and disposable refill brush heads for easy maintenance. Designed for effective cleaning, the brush reaches under the rim and other hard-to-clean areas, ensuring a spotless toilet every time.Perfect for homes, offices, or commercial spaces, this set combines functionality and convenience, making it an essential bathroom cleaning tool. Its compact design keeps it neat and accessible in any restroom.",
        category: "BathroomEssentials",
      },
      {
        id: 4,

        name: "Rapid-Dissolving Toilet Paper",
        price: 9.99,
        sale_price: 8.48,
        description:
          "Ideal for RVs, boats, and portable toilets, this rapid-dissolving toilet paper",
        image: "/assests/productimg/bathroomproducts/4.webp",
        details:
          "Ideal for RVs, boats, and portable toilets, this rapid-dissolving toilet paper is designed to prevent clogs and maintain plumbing systems. Each roll is soft, strong, and dissolves quickly for hassle-free use, making it perfect for travel or small-space bathrooms.Compact and convenient, this 8-roll pack ensures you’re always stocked with essential bathroom supplies while keeping your septic or holding tanks in optimal condition.",
        category: "BathroomEssentials",
      },
      {
        id: 5,

        name: "High-Pressure Rain Shower",
        price: 93.99,
        sale_price: 42.99,
        description:
          "Upgrade your bathroom with this 12-inch high-pressure rain shower head combo",
        image: "/assests/productimg/bathroomproducts/5.webp",
        details:
          "Upgrade your bathroom with this 12-inch high-pressure rain shower head combo, designed to provide a spa-like experience at home. The wide rainfall showerhead ensures full coverage, while the handheld unit with 5 spray modes offers versatility for rinsing and targeted cleaning.Featuring an adjustable extension arm and dual anti-clog nozzles, this showerhead ensures consistent water flow and easy maintenance. Its sleek silver chrome finish adds a modern touch, making it a stylish and functional addition to any bathroom.",
        category: "BathroomEssentials",
      },
      {
        id: 6,

        name: "High-Pressure Rain Shower Head Combo",
        price: 23.99,
        sale_price: 20.88,
        description:
          "Upgrade your bathroom with this high-pressure rain showerhead combo, designed for a relaxing and invigorating shower",
        image: "/assests/productimg/bathroomproducts/6.webp",
        details:
          "Upgrade your bathroom with this high-pressure rain showerhead combo, designed for a relaxing and invigorating shower experience. The set includes a wide rain showerhead for full coverage and a handheld unit with a flexible 60-inch hose for targeted cleaning and convenience.Durable and easy to install, this showerhead combo delivers consistent water flow while enhancing your bathroom’s functionality. Ideal for daily use, it combines comfort, versatility, and modern design in one sleek package.",
        category: "BathroomEssentials",
      },
      {
        id: 7,

        name: "Extendable Tub & Tile Scrubber",
        price: 12.33,
        sale_price: "",
        description:
          "Make bathroom cleaning easier with this extendable tub and tile scrubber",
        image: "/assests/productimg/bathroomproducts/7.webp",
        details:
          "Make bathroom cleaning easier with this extendable tub and tile scrubber. The 28.5-inch reach helps you clean hard-to-access areas without straining. Durable bristles tackle soap scum, grime, and stains efficiently, keeping your tub and tiles sparkling clean.",
        category: "BathroomEssentials",
      },
      {
        id: 8,

        name: "Toilet Bowl Cleaner – Clinging Gel",
        price: 7.6,
        sale_price: 7.3,
        description:
          "Ideal for RVs, boats, and portable toilets, this rapid-dissolving toilet paper",
        image: "/assests/productimg/bathroomproducts/8.webp",
        details:
          "Keep your toilet sparkling clean and fresh with this clinging gel toilet cleaner. The thick formula clings to the bowl, effectively removing stains, limescale, and bacteria while leaving a refreshing ocean mist scent.This 2-pack ensures you’re always stocked for regular cleaning, helping maintain hygiene and freshness in your bathroom. Ideal for home, office, or commercial use.",
        category: "BathroomEssentials",
      },
    ],
  },
  HomeAppliances: {
    products: [
      {
        id: 1,
        name: "3-Quart Air Fryer",
        price: 42.77,
        sale_price: "",
        description:
          "Cook healthier, crispier meals with this 3-quart air fryer",
        image: "/assests/productimg/homeappliances/1.1.webp",
        details:
          "Cook healthier, crispier meals with this 3-quart air fryer featuring advanced TurboCrisp technology. Designed to circulate hot air evenly, it delivers perfectly crispy results with little to no oil, making it ideal for fries, wings, vegetables, and more.The compact design fits comfortably on your countertop, while the easy-to-use controls let you adjust temperature and cooking time for precise results. Its removable basket simplifies cleanup, making healthy cooking convenient and mess-free.",
        category: "HomeAppliances",
      },
      {
        id: 2,
        name: "French Door Air Fryer",
        price: 192.99,
        sale_price: 132.88,
        description:
          "Enjoy versatile cooking with this multi-functional French door appliance.",
        image: "/assests/productimg/homeappliances/2.webp",
        details:
          "Enjoy versatile cooking with this multi-functional French door appliance. Combining an air fryer, pizza oven, and toaster oven in one, it allows you to bake, roast, toast, and air-fry with ease. The stainless steel finish adds a sleek, modern look to your kitchen.Designed for convenience, it features intuitive controls, adjustable temperature settings, and a spacious interior to handle a variety of meals. Perfect for small kitchens, apartments, or anyone looking to save counter space without sacrificing functionality.",
        category: "HomeAppliances",
      },
      {
        id: 3,
        name: "5-in-1 Immersion Hand Blender",
        price: 71.77,
        sale_price: 28.99,
        description:
          "Make cooking and food preparation effortless with this versatile 5-in-1 immersion blender",
        image: "/assests/productimg/homeappliances/3.webp",
        details:
          "Make cooking and food preparation effortless with this versatile 5-in-1 immersion blender. Featuring a powerful 1000W motor and 20-speed settings with turbo mode, it handles blending, chopping, whisking, and pureeing with ease.The set includes a durable stick blender, chopper attachment, whisk, and a 600ml beaker, making it perfect for smoothies, soups, sauces, or baby food. Its ergonomic design ensures comfort and control while blending directly in pots, bowls, or cups.",
        category: "HomeAppliances",
      },
      {
        id: 4,

        name: "2-in-1 Single Serve Coffee Maker",
        price: 34.69,
        sale_price: 66.77,
        description:
          "Brew your favorite coffee your way with this 2-in-1 single serve coffee maker.",
        image: "/assests/productimg/homeappliances/4.webp",
        details:
          "Brew your favorite coffee your way with this 2-in-1 single serve coffee maker. Compatible with K-Cup pods and ground coffee, it offers versatility and convenience for every coffee lover. With brew sizes from 6 to 14 oz and one-press fast brewing, you can enjoy the perfect cup in minutes.The reusable filter helps reduce waste and is easy to clean, making this coffee maker ideal for homes, offices, or small kitchens. Its compact design saves counter space while delivering rich, flavorful coffee every time.",
        category: "HomeAppliances",
      },
      {
        id: 5,

        name: "Electric Griddle ",
        price: 72.99,
        sale_price: 45.99,
        description:
          "Cook breakfast, brunch, or dinner with ease on this spacious 12 x 22 electric griddle.",
        image: "/assests/productimg/homeappliances/5.2.webp",
        details:
          "Cook breakfast, brunch, or dinner with ease on this spacious 12 x 22 electric griddle. The non-stick surface ensures even cooking and easy cleanup, while the XL size allows you to prepare multiple items at once — perfect for families or entertaining guests.The temperature control lets you cook a variety of foods to perfection, from pancakes and eggs to burgers and grilled sandwiches. Its stylish rose finish adds a modern touch to any kitchen countertop.",
        category: "HomeAppliances",
      },
      {
        id: 6,

        name: "Powerful Upright Deep Carpet Cleaner",
        price: 203.99,
        sale_price: 145.99,
        description:
          "Keep your carpets fresh and clean with this upright deep carpet cleaner, designed especially for homes with pets.",
        image: "/assests/productimg/homeappliances/6.webp",
        details:
          "Keep your carpets fresh and clean with this upright deep carpet cleaner, designed especially for homes with pets. Its powerful suction and deep-cleaning brushes remove dirt, pet hair, and stains effectively, leaving carpets looking and feeling revitalized.The XL design covers more area per pass, making cleaning faster and more efficient. Ideal for homes, apartments, or offices, this machine combines convenience, performance, and durability for a thorough carpet cleaning experience.",
        category: "HomeAppliances",
      },
      {
        id: 7,

        name: "Cordless Portable Carpet Shampooer",
        price: 172.99,
        sale_price: 88.29,
        description:
          "Keep your carpets, upholstery, and car interiors spotless with this cordless portable carpet shampooer",
        image: "/assests/productimg/homeappliances/7.webp",
        details:
          "Keep your carpets, upholstery, and car interiors spotless with this cordless portable carpet shampooer. Designed to tackle pet stains, spills, and dirt, it delivers deep cleaning power in a compact, convenient design.Its lightweight and portable build allows for easy maneuvering on carpets, rugs, car seats, and other upholstery. Perfect for homes, apartments, or vehicles, this multi-purpose cleaner combines efficiency, portability, and ease of use for quick and effective cleaning.",
        category: "HomeAppliances",
      },
      {
        id: 8,

        name: "4-Slice Toaster – Black",
        price: 27.99,
        sale_price: "",
        description:
          "Start your day with perfectly toasted bread using this 4-slice toaster",
        image: "/assests/productimg/homeappliances/8.webp",
        details:
          "Start your day with perfectly toasted bread using this 4-slice toaster. Featuring 6 adjustable shade settings, it allows you to customize your toast from light to golden brown. The removable crumb tray ensures easy cleaning and maintenance, keeping your countertop tidy.Its sleek black design complements any kitchen decor, while the wide slots accommodate various bread types, bagels, or pastries. Durable and easy to use, this toaster combines convenience, style, and functionality in one compact appliance.",
        category: "HomeAppliances",
      },
    ],
  },
  FoodBeverages: {
    products: [
      {
        id: 1,
        name: "Fresh Snow Crab Clusters",
        price: 15.77,
        sale_price: "",
        description:
          "Enjoy restaurant-quality seafood at your place with these fresh snow crab clusters.",
        image: "/assests/productimg/food/1.webp",
        details:
          "Enjoy restaurant-quality seafood at home with these fresh snow crab clusters. Each tray includes three 1 lb clusters, packed with approximately 20g of protein per serving, making it a nutritious and flavorful addition to your meals.Perfect for steaming, boiling, or grilling, these snow crab clusters are ideal for family dinners, gatherings, or special occasions. Naturally rich in protein and low in fat, they provide a delicious way to enjoy seafood while supporting a healthy diet.",
        category: "FoodBeverages",
      },
      {
        id: 2,
        name: "Wild-Caught Dungeness Crab Legs",
        price: 40,
        sale_price: "",
        description:
          "Enjoy the rich, sweet flavor of wild-caught Dungeness crab with these fully cooked frozen crab legs.",
        image: "/assests/productimg/food/2.webp",
        details:
          "Enjoy the rich, sweet flavor of wild-caught Dungeness crab with these fully cooked frozen crab legs. Convenient and ready to eat, they make meal prep quick and easy while providing a delicious seafood experience at home.Ideal for steaming, boiling, or reheating, these crab legs are perfect for family dinners, special occasions, or seafood feasts. Naturally high in protein and low in fat, they offer a healthy and satisfying addition to your diet.",
        category: "FoodBeverages",
      },
      {
        id: 3,
        name: "5-in-1 Immersion Hand Blender",
        price: 32.99,
        sale_price: 28.15,
        description:
          "Bring the taste of a seafood feast to your place with this 3 lb frozen seafood mix.",
        image: "/assests/productimg/food/3.webp",
        details:
          "Bring the taste of a seafood feast to your home with this 3 lb frozen seafood mix. Featuring shrimp, snow crab, mussels, and a savory seasoning blend, it’s perfect for boiling, steaming, or grilling for family meals or gatherings.High in protein and rich in flavor, this seafood mix provides a convenient way to enjoy a variety of seafood in one package. Ideal for seafood lovers who want restaurant-quality taste at home.",
        category: "FoodBeverages",
      },
      {
        id: 4,

        name: "Frozen Raw Super Colossal Shrimp",
        price: 10.99,
        sale_price: "",
        description:
          "Enjoy large, flavorful shrimp with this 16 oz bag of frozen raw shrimp.",
        image: "/assests/productimg/food/4.webp",
        details:
          "Enjoy large, flavorful shrimp with this 16 oz bag of frozen raw shrimp. Each shrimp comes shell-on and tail-on, making it easy to peel and perfect for a variety of recipes, from grilling to sautéing.High in protein and naturally low in fat, these shrimp are ideal for quick, nutritious meals. The 13–15 count per pound ensures generous portions for family dinners, gatherings, or seafood feasts.",
        category: "FoodBeverages",
      },
      {
        id: 5,

        name: "Lemonade Drink – 1L Bottle",
        price: 65,
        sale_price: 57.1,
        description:
          "Refresh and hydrate with this classic lemonade drink. Bursting with zesty lemon flavor.",
        image: "/assests/productimg/beverages/1.webp",
        details:
          "Refresh and hydrate with this classic lemonade drink. Bursting with zesty lemon flavor, it’s perfect for quenching your thirst on a hot day or pairing with meals.Conveniently packaged in a 1L bottle, it’s ideal for sharing with family and friends or enjoying throughout the day. Crisp, tangy, and lightly sweetened, this lemonade delivers a refreshing taste in every sip.",
        category: "FoodBeverages",
      },
      {
        id: 6,

        name: "Blue Raspberry Juice Drink",
        price: 39.1,
        sale_price: "",
        description:
          "Enjoy a burst of bold, fruity flavor with this Blue Raspberry Juice Drink.",
        image: "/assests/productimg/beverages/2.webp",
        details:
          "Enjoy a burst of bold, fruity flavor with this Blue Raspberry Juice Drink. Each 2-pack includes 15 convenient 11.3 fl oz bottles, perfect for on-the-go refreshment, lunchboxes, or family gatherings.This shelf-stable beverage offers a deliciously sweet and tangy taste that kids and adults will love. Serve chilled for the ultimate refreshing experience anytime, anywhere.",
        category: "FoodBeverages",
      },
      {
        id: 7,

        name: "Zero Sugar Energy Drink",
        price: 33.99,
        sale_price: 25.29,
        description:
          "Keep your carpets, upholstery, and car interiors spotless with this cordless portable carpet shampooer",
        image: "/assests/productimg/beverages/3.webp",
        details:
          "Power up your day with this bold and tangy Black Cherry Zero Sugar Energy Drink. Each 16 oz can delivers smooth, balanced energy without the crash, featuring a deliciously sour twist inspired by classic candy flavors.With zero sugar and a refreshing taste, this 12-pack is perfect for workouts, gaming sessions, or whenever you need a boost. Stay energized and focused with a drink that tastes as good as it performs.",
        category: "FoodBeverages",
      },
      {
        id: 8,

        name: "Peach Fruit Juice Drink",
        price: 3,
        sale_price: "",
        description:
          "Delight in the sweet, juicy taste of ripe peaches with this refreshing Peach Fruit Juice Drink.",
        image: "/assests/productimg/beverages/4.webp",
        details:
          "Delight in the sweet, juicy taste of ripe peaches with this refreshing Peach Fruit Juice Drink. Perfectly balanced with natural flavor and smooth texture, it’s a delicious choice for breakfast, brunch, or any time of day.Packaged in a convenient 59 fl oz carton, it’s ideal for families and easy to pour. Serve chilled for a cool, fruity refreshment everyone will enjoy.",
        category: "FoodBeverages",
      },
    ],
  },
  PetsCare: {
    products: [
      {
        id: 1,
        name: "Adult Small Dog Dry Dog Food – Grilled Steak & Vegetable Flavor, 3.5 lb Bag",
        price: 6.83,
        sale_price: "",
        description:
          "Dry dog food formulated for adult small breed dogs, featuring small kibble pieces in a grilled steak and vegetable flavor.",
        image: "/assests/productimg/petscare/1.webp",
        details:
          "This dry dog food is designed to meet the nutritional needs of adult small breed dogs. It contains 36 essential vitamins, minerals, and amino acids to support overall health and vitality. The formula includes high-quality protein to maintain lean muscles, prebiotic fiber to promote healthy digestion, and omega-6 fatty acids and zinc to nourish the skin and coat. The small-sized kibble is tailored for small mouths and helps clean teeth with every bite. This recipe is made in the USA with the finest ingredients from around the world and contains no high fructose corn syrup, artificial flavors, or added sugars.",
        category: "PetsCare",
      },
      {
        id: 2,
        name: "Small Breed Dry Dog Food – Farm-Raised Beef & Vegetables, 3.5 lb Bag",
        price: 7.28,
        sale_price: "",
        description:
          "Dry dog food formulated for adult small breed dogs, featuring farm-raised beef as the primary ingredient, complemented by vegetables and added vitamins and minerals.",
        image: "/assests/productimg/petscare/2.webp",
        details:
          "This dry dog food is specifically designed to meet the nutritional needs of adult small breed dogs. It contains farm-raised beef as the number one ingredient, providing high-quality protein to support strong muscles. The formula includes 23 essential vitamins and minerals to promote overall health and wellness. Additionally, it contains calcium to support healthy teeth and bones. The kibble is sized appropriately for small mouths, making it easy to chew and digest. This recipe is made without artificial preservatives or flavors, and added colors are derived from natural sources.",
        category: "PetsCare",
      },
      {
        id: 3,
        name: "Tender Chicken Recipe with Carrots, Peas & Brown Rice – Slice & Serve Roll, 6 lb",
        price: 18.5,
        sale_price: "",
        description:
          "A fresh, refrigerated dog food roll made with tender chicken, carrots, peas, and brown rice, gently steamed to retain nutrients.",
        image: "/assests/productimg/petscare/3.webp",
        details:
          "This wholesome dog food roll is crafted with natural, U.S.-farm-raised chicken as the primary ingredient, complemented by carrots, peas, and high-fiber brown rice. The ingredients are gently steam-cooked to preserve essential nutrients, providing a balanced meal for your dog.The formula includes chicken liver, eggs, and spinach, offering a rich source of vitamins and minerals to support overall health. Additionally, the recipe is designed to support healthy digestion. This product is free from preservatives and artificial additives, ensuring a natural diet for your pet. It is packaged in a convenient roll form, making it easy to slice and serve according to your dog's dietary needs.",
        category: "PetsCare",
      },
      {
        id: 4,

        name: "Durable Crocodile-Shaped Chew Toy for Aggressive Chewers – Interactive, Heavy-Duty Rubber & Nylon Design for Large & Medium Dogs",
        price: 22.99,
        sale_price: 13.99,
        description:
          "Designed for aggressive chewers, this indestructible crocodile-shaped toy combines durable rubber and nylon to withstand intense chewing sessions, promoting dental health and providing interactive play for large and medium dogs.",
        image: "/assests/productimg/petscare/4.webp",
        details:
          "This heavy-duty chew toy is crafted to endure the powerful jaws of aggressive chewers, making it ideal for large and medium-sized dogs. The unique crocodile shape not only attracts your dog's attention but also serves as an interactive tool to reduce boredom and anxiety. Made from a combination of tough rubber and nylon, the toy offers varied textures that help clean teeth, massage gums, and promote healthy chewing habits. Its design allows you to apply dog-safe toothpaste or treats, enhancing the chewing experience and encouraging dental hygiene. Suitable for dogs weighing between 20 to 100 lbs, this toy is virtually indestructible, ensuring long-lasting durability. Please supervise your dog during play to ensure safety.",
        category: "PetsCare",
      },
      {
        id: 5,

        name: "Interactive Chirping Bird Cat Toy – Feathered Plush with Catnip, Rechargeable, for Indoor Cats",
        price: 10.99,
        sale_price: "",
        description:
          "A lifelike, touch-activated bird toy that flaps its wings and emits realistic chirping sounds to engage indoor cats in active play.",
        image: "/assests/productimg/petscare/5.webp",
        details:
          "This interactive cat toy is designed to mimic the movement and sound of a real bird, stimulating your cat's natural hunting instincts. It features a soft, feathered body and emits realistic chirping sounds when touched. The toy is rechargeable, ensuring hours of entertainment without the need for constant battery replacements. It's ideal for indoor cats, providing both physical exercise and mental stimulation. The compact size and lightweight design make it easy to use and store.",
        category: "PetsCare",
      },
      {
        id: 6,

        name: "1-Gallon Plastic Aquarium with Accessories",
        price: 12.99,
        sale_price: "",
        description:
          "A compact, 1-gallon plastic aquarium ideal for small fish, featuring a durable construction and clear visibility.",
        image: "/assests/productimg/petscare/6.webp",
        details:
          "This 1-gallon plastic aquarium is designed for small fish such as bettas or goldfish. Its compact size makes it suitable for desktops or small spaces. The aquarium is constructed from durable plastic, ensuring longevity and resistance to breakage. Its clear walls provide excellent visibility, allowing for an unobstructed view of your aquatic pets. Please note that gravel, decorations, and fish are sold separately.",
        category: "PetsCare",
      },
      {
        id: 7,

        name: "Daily Essentials Dry Cat Food – Chicken, Beef & Salmon Flavors, 15.5 lb Bag",
        price: 16.98,
        sale_price: "",
        description:
          "Dry cat food formulated for adult cats, featuring a blend of chicken, beef, and salmon flavors, designed to support overall health and wellness.",
        image: "/assests/productimg/petscare/7.webp",
        details:
          "This dry cat food offers a balanced diet for adult cats, combining the flavors of chicken, beef, and salmon to appeal to your cat's taste preferences. The formula includes high-quality protein to support strong muscles, taurine to maintain heart health and clear vision, and omega-3 fatty acids to promote healthy skin and coat. Additionally, it contains essential vitamins and minerals to support overall health and vitality. The 15.5 lb bag provides a convenient size for households with multiple cats or those seeking to stock up on their pet's food.",
        category: "PetsCare",
      },
      {
        id: 8,

        name: "Original Poultry, Liver & Ocean Fish Flavors Dry Cat Food – 22 lb Bag",
        price: 20.68,
        sale_price: "",
        description:
          "Dry cat food formulated for adult cats, featuring a blend of poultry, liver, and ocean fish flavors, designed to support overall health and wellness.",
        image: "/assests/productimg/petscare/8.webp",
        details:
          "This dry cat food offers a balanced diet for adult cats, combining the flavors of poultry, liver, and ocean fish to appeal to your cat's taste preferences. The formula includes high-quality protein to support strong muscles, taurine to maintain heart health and clear vision, and omega-3 fatty acids to promote healthy skin and coat. Additionally, it contains essential vitamins and minerals to support overall health and vitality. The 22 lb bag provides a convenient size for households with multiple cats or those seeking to stock up on their pet's food. The kibble is shaped in fun, crunchy pieces that help promote clean teeth and encourage healthy chewing habits. Proudly made in the USA, this cat food is crafted in facilities that meet industry standards for quality and safety.",
        category: "PetsCare",
      },
    ],
  },
};
